<ptg-add-property *ngIf="!data?.isEdit; else editProperty"
                  [data]="data.property"
                  (closeDialog)="closeDialog($event)" [metadataProperties]="data.metadataProperties"></ptg-add-property>

<ng-template #editProperty>
  <ptg-edit-property [metadataProperties]="data.metadataProperties" [data]="data.property" [itemKey]="data.itemKey" [lookupTables]="data.lookupTables" (closeDialog)="closeDialog($event)"></ptg-edit-property>
</ng-template>
